<template>
	<div class="content-edit-listing-mobile">
		<b-container fluid="xl">
			<h4 class="title">
				{{
					firstStep
						? $t('addListing.details.details')
						: secondStep
						? $t('addListing.preview.preview')
						: $t('addListing.neat.neat')
				}}
			</h4>
			<div class="steper-add-listing">
				<div class="divider"></div>
				<div class="stepper-circle">
					<div class="circle-title" v-bind:class="{ selected: firstStep }">
						<div class="circle">
							<PencilIcon />
						</div>
					</div>
					<!-- <div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<MagnifyIcon />
						</div>
					</div> -->
					<div class="circle-title" v-bind:class="{ selected: secondStep }">
						<div class="circle">
							<CheckIcon />
						</div>
					</div>
				</div>
			</div>
			<div class="trasnlation-div d-flex flex-row justify-content-start align-items-start" v-if="supportedLanguages.length>1&&projectConfig.affiliate != 'Khaosod'||false">
					<template v-for="(item, key) in supportedLanguages">
						<div :key="key" class="lang-div d-flex flex-row justify-content-center align-items-center p-2" :class="selectedLangugae==item?'active-lang':''"
							@click="changeLanguageTab(item)">
							<span v-if="selectedLangugae==item" >
									{{$t('addListing.details.selectLanguage'+item)}}
							</span>
							<span v-else>
									{{$t('addListing.details.selectLanguage'+item)}}
							</span>
							
						</div>
					</template>
					
				</div>
			<template v-if="firstStep">
				
				<!-- Translate call-to-action -->
					<template v-for="(item, key) in supportedLanguages">
						
						<b-row :key="'B'+key" class="translate-row mt-3 mb-4" align-v="center" v-if="projectConfig.affiliate != 'Khaosod'||false&&key!=0&&item==selectedLangugae">
							
								<b-col cols="8">
									<p class="mb-0 mt-3">
										{{$t('addListing.details.translateNote1',selectedLangugae)}}
									</p>
									<p class="mt-0">
										{{$t('addListing.details.translateNote2',selectedLangugae)}}
									</p>
									<p class="small">
										{{$t('addListing.details.translateNote3',selectedLangugae)}}
									</p>
								</b-col>
								<b-col class="text-center">
									<b-button class="translate-btn" @click="trasnlateToOtherLanguage()">
										{{$t('addListing.details.translateTo',selectedLangugae)}} {{$t('addListing.details.'+selectedLangugae)}}
									</b-button>
								</b-col>
							
						</b-row>
					</template>
				<b-form class="form-add-listing">
					<b-row>
						<!-- Main category -->
						<b-col cols="12">
							<b-form-group
								:label="$t('addListing.details.selectProductCategory', selectedLangugae)"
							>
								<b-button
									class="btn-category"
									id="mainCategory"
									@click="
										isActiveCategory = !isActiveCategory;
									"
								>
									{{ listing.mainCategory ?  $t(listing.mainCategory.name) : '' }}
									<IconChevronDown />
								</b-button>
							</b-form-group>
						</b-col>
						<!-- Sub category -->
						<b-col cols="12" v-if="childCategories.listing_category_children.length">
							<b-form-group :label="$t('Select a subcategory')">
								<b-button
									class="btn-category"
									id="childCategory"
									@click="isActiveCateChild = !isActiveCateChild"
									:class="{
											'input-error': validateErrors
												? validateErrors.idSubListing
												: false
										}"
								>
									{{
										listing.subCategory
											? $t(listing.subCategory.name)
											: $t('addListing.details.selectSubCategory', selectedLangugae)
									}}
									<IconChevronDown />
								</b-button>
							</b-form-group>
						</b-col>
						<b-col cols="12"
									v-if="childCategories.childSubCategory.listing_category_children.length">
							<b-form-group :label="$t('Select a subcategory')">
								<b-button
									class="btn-category"
									id="childCategory"
									@click="isActiveCateChildChild = !isActiveCateChildChild"
									:class="{
											'input-error': validateErrors
												? validateErrors.idsubSubListing
												: false
										}"
								>
									{{
										listing.subSubCategory && listing.subSubCategory.name
											? $t(listing.subSubCategory.name)
											: $t('addListing.details.selectSubCategory', selectedLangugae)
									}}
									<IconChevronDown />
								</b-button>
							</b-form-group>
									
						</b-col>
						<!-- Product name -->
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_title)">
								<b-form-input
									v-model="listing.title"
									:placeholder="$t(childCategories.field_name_title)"
									:class="{
										'input-error': validateErrors ? validateErrors.title : false
									}"
								></b-form-input>
							</b-form-group>
						</b-col>
						<!-- Attributes -->
						<template
							v-for="(item, key) in childCategories.category_attribute_details"
						>
							<b-col
								:key="key"
								cols="12"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Radio button'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<span v-if="item.id==23||item.id==135" style="position: absolute;right: 100px;">
									<b-icon-question-circle variant="primary" id="price-info" style="color:var(--projectPrimaryColor) !important;"/>
									<b-tooltip
										custom-class="website-tool-tips"
										placement="righttop"
										target="price-info"
									>
										{{$t('addListing.details.rentOrSaleNote', selectedLangugae)}}
									</b-tooltip>
								</span>
									<b-form-radio-group
										:name="`radio-sub-component-${key + 1}`"
										class="group-radio"
										v-model="
											listing.listingAttr.data[`radioValue_${item.attr_id}`]
										"
										@change="
										changeRadioValue($event, `radioValue_${item.attr_id}`)
									"
									>
										<b-form-radio
											:value="value.id"
											v-for="(value, k) in item.listing_attribute
												.listing_pre_values"
											:key="k"
											>{{ $t(value.value) }}</b-form-radio
										>
									</b-form-radio-group>
								</b-form-group>
								
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Textbox'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										<b-form-input
											:placeholder="$t(item.listing_attribute.name)"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
										></b-form-input>
										<template
											v-if="
												item.listing_attribute.listing_attributes_children
													.length
											"
										>
											<template
												v-for="(value, ke) in item.listing_attribute
													.listing_attributes_children"
											>
												<b-form-input
													:placeholder="$t(value.name)"
													:key="ke"
													v-if="value.listing_attributes_type.type == 'Textbox'"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													class="mt-10"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
												<b-dropdown no-flip
													:key="ke"
													class="menu-dropdown mt-10"
													v-if="
														value.listing_attributes_type.type ==
															'Select option'
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
													<template v-slot:button-content>
														<span>
															{{
																dropdownChooseValue[`selectValue_${value.id}`]?
																$t(dropdownChooseValue[`selectValue_${value.id}`]):
																$t(value.placeholder)
															}}
															<IconChevronDown />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, k) in value.listing_pre_values"
														:key="k"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[`selectValue_${value.id}`] =
																val.value;
														"
														>{{ $t(val.value)}}</b-dropdown-item
													>
												</b-dropdown>
											</template>
										</template>
									</template>
								</b-form-group>
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Select option'
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										<b-dropdown no-flip
											class="menu-dropdown"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `selectValue_${item.attr_id}`
													)
											}"
										>
											<template v-slot:button-content>
												<span>
													{{
														dropdownChooseValue[`selectValue_${item.attr_id}`]?
														$t(dropdownChooseValue[`selectValue_${item.attr_id}`]):
														$t(item.placeholder)
													}}
													<IconChevronDown />
												</span>
											</template>
											<b-dropdown-item
												v-for="(value, k) in item.listing_attribute
													.listing_pre_values"
												:key="k"
												@click="
													listing.listingAttr.data[
														`selectValue_${item.attr_id}`
													] = value.id;
													dropdownChooseValue[`selectValue_${item.attr_id}`] =
														value.value;
												"
												>{{ $t(value.value) }}</b-dropdown-item
											>
										</b-dropdown>
									</template>
								</b-form-group>
							</b-col>
							<b-col
								cols="12"
								:key="key"
								v-if="
									item.listing_attribute.listing_attributes_type.type ==
										'Number' && !listing.listingAttr.data.radioValue_18
								"
							>
								<b-form-group :label="$t(item.listing_attribute.name)">
									<template>
										
										<masked-input
											type="text"
											class="form-control mb-2"
											v-model="
												listing.listingAttr.data[`inputValue_${item.attr_id}`]
											"
											:class="{
												'input-error':
													isValidate &&
													!validateInputDynamic.some(
														temp => temp === `inputValue_${item.attr_id}`
													)
											}"
											:mask="numberAmountMask()"
											:placeholder="$t(item.listing_attribute.name)"
											:disabled="item.listing_attribute.disabled"
										></masked-input>
										<template
											v-if="
												item.listing_attribute.listing_attributes_children
													.length
											"
										>
											<template
												v-for="(value, k) in item.listing_attribute
													.listing_attributes_children"
											>
												<b-form-input
													:placeholder="$t(value.name)"
													:key="k"
													v-if="value.listing_attributes_type.type == 'Textbox'"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													class="mt-10"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
												></b-form-input>
												<masked-input
													v-if="value.listing_attributes_type.type == 'Number'"
													class="form-control mt-10"
													:key="k"
													type="text"
													v-model="
														listing.listingAttr.data[`inputValue_${value.id}`]
													"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `inputValue_${value.id}`
															)
													}"
													:mask="numberAmountMask()"
													:placeholder="$t(value.name)"
												></masked-input>

												<b-dropdown no-flip
													:key="k"
													v-if="
														value.listing_attributes_type.type == 'Select option'
													"
													class="menu-dropdown d-flex flex-row justify-content-center"
													:class="{
														'input-error':
															isValidate &&
															!validateInputDynamic.some(
																temp => temp === `selectValue_${value.id}`
															)
													}"
												>
													<template v-slot:button-content>
														<span>
															{{
																dropdownChooseValue[`selectValue_${value.id}`]?
																$t(dropdownChooseValue[`selectValue_${value.id}`]):
																$t(value.placeholder)
															}}
															<IconChevronDown />
														</span>
													</template>
													<b-dropdown-item
														v-for="(val, k) in value.listing_pre_values"
														:key="k"
														@click="
															listing.listingAttr.data[
																`selectValue_${value.id}`
															] = val.id;
															dropdownChooseValue[`selectValue_${value.id}`] = val.value;
														"
														>{{ $t(val.value)}}</b-dropdown-item
													>
												</b-dropdown>
												
											<b-form-checkbox 
												:key="k"
												v-if="value.listing_attributes_type.type == 'Checkbox'"
											 	:value="true" :unchecked-value="false" 
												 @input="item.listing_attribute.disabled=listing.listingAttr.data[`checkboxValue_${value.id}`]"
												v-model="listing.listingAttr.data[`checkboxValue_${value.id}`]">
												{{$t(value.placeholder)}}
												</b-form-checkbox>
												
											</template>
										</template>
									</template>
								</b-form-group>
							</b-col>
						</template>
						<b-col
							cols="12"
							
						>
							<b-form-group>
								<template v-slot:label>
									{{ $t('addListing.details.price', selectedLangugae) }}
									<b-icon-question-circle variant="primary" id="price-info" />
								</template>
								<b-tooltip
									custom-class="website-tool-tips"
									target="price-info"
									triggers="click"
								>
									{{$t('addListing.details.priceNote', selectedLangugae)}}
								</b-tooltip>
								<masked-input
									type="text"
									class="form-control"
									v-model="listing.price"
									:class="{
										'input-error': validateErrors ? validateErrors.price : false
									}"
									:mask="numberAmountMask()"
									:placeholder="$t('addListing.details.price', selectedLangugae)"
								></masked-input>
								
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group
								:label="$t('addListing.details.productImages', selectedLangugae)"
								class="upload-div"
							>
								<Fileuploader
									name="files"
									:maxFiles="'10'"
									:class="{
										'input-error': validateErrors
											? validateErrors.imageError
											: false
									}"
									accept="jpg, png, jpeg"
									:hideFileUploader="hideFileUploader"
									:multiple="true"
									v-on:childToParent="getFile"
									:fileUploaded="arrImageUploaded"
									:theme="'thumbnails'"
									:changeInput="' '"
								/>
								<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Recommend picture size 1200x675 pixel')}}</p>
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_description)">
								<b-form-textarea
									:placeholder="$t(childCategories.field_name_description)"
									v-model="listing.description"
									class="product-detail"
									:class="{
										'input-error': validateErrors
											? validateErrors.description
											: false
									}"
									rows="3"
								></b-form-textarea>
							</b-form-group>
						</b-col>
						<b-col cols="12">
							<b-form-group :label="$t('addListing.details.keywords')" >
								<b-form-tags
									input-id="tags-validation"
									:input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
									separator=" ,;"
									remove-on-delete
									:tag-validator="tagValidator"
									v-model="listing.keywords"
									class="mb-2"
									tag-pills
									size="md"
									:placeholder="$t('addListing.details.keywordsPlaceholder',selectedLangugae)"
									isDuplicate="false"
								></b-form-tags>
								<p style="font-size: 12px;color: gray;padding-top: 10px;">{{$t('Please fill keywords relate with your listing for customer searching and found you listing')}}</p>
							</b-form-group>
						</b-col>
						<!-- google maps-->
						<b-col>
							<b-form-group :label="$t('addListing.details.Address',selectedLangugae)">
								<b-row>
								<b-col cols="8" class="pr-0">
									
									<div class="input-div row no-gutters">
										<b-form-input
											:placeholder="$t('addListing.details.Address',selectedLangugae)"
											class="input-search"
											:class="{
												'input-error': validateErrors
													? validateErrors.address
													: false
											}"
											v-model="loclationAddress"
											disabled
											style="border-bottom-right-radius: 0!important; border-top-right-radius: 0!important;"
										></b-form-input>
									</div>
								</b-col>
								<b-col cols="4" class="pl-0 d-flex flex-row justify-content-start align-items-center">
									<div class="input-div row no-gutters" style="width: 100%;">
										<div class="show-google-maps" v-b-modal.showgooglemap-model>{{$t('addListing.details.showOnMap',selectedLangugae)}}</div>
									</div>
								</b-col>
								</b-row>
							</b-form-group>
							<b-modal
									id="showgooglemap-model"
									class="listing-preview-dialog"
									:title="$t('Preview Listing')"
									size="xl"
									scrollable
									hide-footer
									hide-header
									ref="showgooglemap-model"
									center
									no-close-on-backdrop
									no-close-on-esc
								>
									<div @click="cancel()" class="close-modal ">
										<CloseIcon style="font-size:32px;" />
									</div>
									<AreaSelection @initLatLng="getSelectedArea" v-if="!mapAreaSelected"></AreaSelection>
									<p v-if="mapAreaSelected" style="
										line-height: 1.5;
										font-weight: bolder;
										font-size: 20px;
									">
									{{$t('addListing.details.firstText',selectedLangugae)}} [ <img :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})" src="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png" 
									draggable="false" style="width: 20px; height: 30px;"> ] - 
									{{$t('addListing.details.secondText',selectedLangugae)}} <br>{{$t('addListing.details.thirdText',selectedLangugae)}} [
									<img :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})" src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2223%22%20height%3D%2238%22%20viewBox%3D%220%200%2023%2038%22%3E%0A%3Cpath%20d%3D%22M16.6%2C38.1h-5.5l-0.2-2.9-0.2%2C2.9h-5.5L5%2C25.3l-0.8%2C2a1.53%2C1.53%2C0%2C0%2C1-1.9.9l-1.2-.4a1.58%2C1.58%2C0%2C0%2C1-1-1.9v-0.1c0.3-.9%2C3.1-11.2%2C3.1-11.2a2.66%2C2.66%2C0%2C0%2C1%2C2.3-2l0.6-.5a6.93%2C6.93%2C0%2C0%2C1%2C4.7-12%2C6.8%2C6.8%2C0%2C0%2C1%2C4.9%2C2%2C7%2C7%2C0%2C0%2C1%2C2%2C4.9%2C6.65%2C6.65%2C0%2C0%2C1-2.2%2C5l0.7%2C0.5a2.78%2C2.78%2C0%2C0%2C1%2C2.4%2C2s2.9%2C11.2%2C2.9%2C11.3a1.53%2C1.53%2C0%2C0%2C1-.9%2C1.9l-1.3.4a1.63%2C1.63%2C0%2C0%2C1-1.9-.9l-0.7-1.8-0.1%2C12.7h0Zm-3.6-2h1.7L14.9%2C20.3l1.9-.3%2C2.4%2C6.3%2C0.3-.1c-0.2-.8-0.8-3.2-2.8-10.9a0.63%2C0.63%2C0%2C0%2C0-.6-0.5h-0.6l-1.1-.9h-1.9l-0.3-2a4.83%2C4.83%2C0%2C0%2C0%2C3.5-4.7A4.78%2C4.78%200%200%2C0%2011%202.3H10.8a4.9%2C4.9%2C0%2C0%2C0-1.4%2C9.6l-0.3%2C2h-1.9l-1%2C.9h-0.6a0.74%2C0.74%2C0%2C0%2C0-.6.5c-2%2C7.5-2.7%2C10-3%2C10.9l0.3%2C0.1%2C2.5-6.3%2C1.9%2C0.3%2C0.2%2C15.8h1.6l0.6-8.4a1.52%2C1.52%2C0%2C0%2C1%2C1.5-1.4%2C1.5%2C1.5%2C0%2C0%2C1%2C1.5%2C1.4l0.9%2C8.4h0Zm-10.9-9.6h0Zm17.5-.1h0Z%22%20style%3D%22fill%3A%23333%3Bopacity%3A0.7%3Bisolation%3Aisolate%22%2F%3E%0A%3Cpath%20d%3D%22M5.9%2C13.6l1.1-.9h7.8l1.2%2C0.9%22%20style%3D%22fill%3A%23ce592c%22%2F%3E%0A%3Cellipse%20cx%3D%2210.9%22%20cy%3D%2213.1%22%20rx%3D%222.7%22%20ry%3D%220.3%22%20style%3D%22fill%3A%23ce592c%3Bopacity%3A0.5%3Bisolation%3Aisolate%22%2F%3E%0A%3Cpath%20d%3D%22M20.6%2C26.1l-2.9-11.3a1.71%2C1.71%2C0%2C0%2C0-1.6-1.2H5.7a1.69%2C1.69%2C0%2C0%2C0-1.5%2C1.3l-3.1%2C11.3a0.61%2C0.61%2C0%2C0%2C0%2C.3.7l1.1%2C0.4a0.61%2C0.61%2C0%2C0%2C0%2C.7-0.3l2.7-6.7%2C0.2%2C16.8h3.6l0.6-9.3a0.47%2C0.47%2C0%2C0%2C1%2C.44-0.5h0.06c0.4%2C0%2C.4.2%2C0.5%2C0.5l0.6%2C9.3h3.6L15.7%2C20.3l2.5%2C6.6a0.52%2C0.52%2C0%2C0%2C0%2C.66.31h0l1.2-.4a0.57%2C0.57%2C0%2C0%2C0%2C.5-0.7h0Z%22%20style%3D%22fill%3A%23fdbf2d%22%2F%3E%0A%3Cpath%20d%3D%22M7%2C13.6l3.9%2C6.7%2C3.9-6.7%22%20style%3D%22fill%3A%23cf572e%3Bopacity%3A0.6%3Bisolation%3Aisolate%22%2F%3E%0A%3Ccircle%20cx%3D%2210.9%22%20cy%3D%227%22%20r%3D%225.9%22%20style%3D%22fill%3A%23fdbf2d%22%2F%3E%0A%3C%2Fsvg%3E%0A" aria-label="Street View Pegman Control" 
									style="height: 30px; width: 30px;"> ] {{$t('addListing.details.fourthText',selectedLangugae)}}</p>
									<div v-if="mapAreaSelected" style="position: relative;">
										<div class="location-button " >
											<b-button @click="getMyLocation()" class="get-location-button m-3">
												<IconLocation style="color:white;"/>
											</b-button>
										</div>
										<google-map
												
												ref="mapRef"
												:center="{ lat: lat, lng: lng }"
												:zoom="15"
												style="width: 100%;height:50vh"
												@click="putMarker($event)"
												:options="{
													zoomControl: false,
													mapTypeControl: false,
													scaleControl: true,
													streetViewControl: true,
													rotateControl: false,
													fullscreenControl: false,
													disableDefaultUI: true,
													gestureHandling:'greedy'
												}"
											>
												<google-marker
													ref="myMarker"
													:position="
														google &&
															new google.maps.LatLng(markerLat, markerLng)
													"
													:draggable="true"
													:clickable="true"
													:animation="1"
													@position_changed="getPosition($event)"
													@click="getPosition($event)"
												></google-marker>
										</google-map>
									</div>
										<div style="color:red" v-if="mapAreaSelected">
											{{$t('addListing.details.mapNote',selectedLangugae)}}
										</div>
										<div class="footer" v-if="mapAreaSelected">
											<!-- Emulate built in modal footer ok and cancel button actions -->
											<b-button class="cancel-button mr-5" style="width:150px;"  variant="danger" @click="cancel()">{{$t('addListing.details.cancel',selectedLangugae)}}</b-button>
											<b-button class="okay-button success-button mr-5" style="width:150px;"  variant="success" @click="ok()">{{$t('addListing.details.ok',selectedLangugae)}}</b-button>
											<!-- Button with custom close trigger value -->
										</div>
								</b-modal>
						</b-col>
						<!-- Province / District -->
						<b-col cols="12">
							<b-form-group :label="$t(childCategories.field_name_location)">
								<b-dropdown no-flip
									class="menu-dropdown"
									:class="{
										'input-error': validateErrors ? validateErrors.state : false
									}"
								>
									<template v-slot:button-content>
										{{
											listing.state
												? $t(listing.state.name)
												: $t('addListing.details.province',selectedLangugae)
										}}
										<IconChevronDown />
									</template>
									<b-dropdown-item
										v-for="(province, key) in arrListProvince"
										v-bind:key="`sub-category-${key}`"
										@click="handleProvinceChange(province)"
										>{{ $t(province.name) }}</b-dropdown-item
									>
								</b-dropdown>
								<b-dropdown no-flip
									class="menu-dropdown mt-10"
									:disabled="!listing.state"
									:class="{
										'input-error': validateErrors
											? validateErrors.district
											: false
									}"
								>
									<template v-slot:button-content>
										{{
											listing.district
												? $t(listing.district.name)
												: $t('addListing.details.district',selectedLangugae)
										}}
										<IconChevronDown />
									</template>
									<b-dropdown-item
										v-for="(district, key) in arrListDistrict"
										v-bind:key="`sub-category-${key}`"
										@click="listing.district = district"
										>{{ $t(district.name) }}</b-dropdown-item
									>
								</b-dropdown>
							</b-form-group>
						</b-col>
						<b-col cols="12" class="contact-details">
							<b-form-group :label="$t('addListing.details.contactDetails',selectedLangugae)">
								<b-form-checkbox v-model="listing.takeContactFromDashboard">{{
									$t('addListing.details.takeFromDashboard',selectedLangugae)
								}}</b-form-checkbox>
							</b-form-group>
							<b-form-group>
								<b-form-input
									:placeholder="$t('user.email',selectedLangugae)"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.phoneAndEmail
											: false
									}"
									v-model="listing.email"
									:disabled="listing.takeContactFromDashboard"
								></b-form-input>
							</b-form-group>
							<b-form-group>
								<b-form-input
									type="number"
									:placeholder="$t('only numbers')"
									class="input-search"
									:class="{
										'input-error': validateErrors
											? validateErrors.phoneAndEmail
											: false
									}"
									v-model="listing.phoneNumber"
									:disabled="listing.takeContactFromDashboard"
								></b-form-input>
							</b-form-group>
							<b-form-group>
								<div class="d-flex flex-row  no-gutters">
									<img :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})" src="/images/line.png" style="width: 35px;height:35px; margin-right: 10px;"/>
									<b-form-input
										:placeholder="$t('line',selectedLangugae)"
										class="input-search"
										v-model="listing.line_id"
										:disabled="listing.takeContactFromDashboard"
									></b-form-input>
								</div>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
				<b-row>
					<!-- Packages -->
					<b-modal
						id="package-model"
						class="package-model"
						title="Preview Listing"
						size="xl"
						scrollable
						hide-footer
						hide-header
						ref="package-model"
						center
						no-close-on-backdrop
						no-close-on-esc
						>
						<div class="package-model">
							<Packages
								v-if="arrUserPayment || $route.name === 'AddListing'"
								@childToParent="getSelectedPackages"
								:userPayment="arrUserPayment"
								:website="listing.website"
							/>
							<div class="footer " >
								<!-- Emulate built in modal footer ok and cancel button actions -->
								<b-button class="cancel-button ml-3 mr-2" 
								style="width:100px;border: 1px solid var(--projectPrimaryColor)!important;background-color: white!important;color: var(--projectPrimaryColor) !important;"  
								variant="danger" @click="toggleAdsImag()">{{$t('addListing.details.skipPackage')}}</b-button>
								<b-button class="okay-button success-button mr-5" style="width:100px;"  variant="success" 
								@click="addPackage()" :disabled="disabledPackageButton">{{$t('addListing.details.ok')}}</b-button>
								<!-- Button with custom close trigger value -->
							</div>
						</div>
					</b-modal>
					<b-modal
						id="image-ads-model"
						class="image-ads-model"
						hide-footer
						hide-header
						ref="image-ads-model"
						centered
						size="lg"
						no-close-on-backdrop
						no-close-on-esc
						>
							
							<div style="position: relative;">
								<img class="mobile-image" :src="'/images/popup/ads-image-'+selectedLanguage+'.png'"/>
								<img :src="'/images/popup/upgrade.png'"
								style="position: absolute;width: 35%;
								right: 0;top:34px;cursor: pointer;" @click="openPakcageDialog()"/>
								
								<img class="no-mobile-image" :src="'/images/popup/no-'+selectedLanguage+'.png'" @click="addPackage(true)"/>
								<img class="yes-mobile-image" :src="'/images/popup/yes-'+selectedLanguage+'.png'"   @click="openPakcageDialog()"  />
							</div>
					</b-modal>
					<b-col cols="12" class="button-func">
						<div class="text">
							{{ $t('addListing.details.clickPostToAccept') }}
							<p>{{ $t('addListing.details.termsCondition') }}</p>
						</div>
						<b-button
							type="button"
							class="btn-submit-search"
							v-on:click="openPakcageDialog()"
							:disabled="disabled"
							>{{ $t('addListing.details.post') }}</b-button
						>
					</b-col>
				</b-row>
				<b-modal
					id="listing-preview-dialog-first"
					centered
					hide-footer
					hide-header
					size="lg"
					no-close-on-backdrop
				>
					<b-row class="button-second-step">
						<b-col cols="12" class="text-center step-info">
							<IconClipboardList class="icon-clipboard" />
							<h4>{{ $t('addListing.details.listingUnderReview') }}</h4>
							<!-- <p style="margin-bottom:0;">{{ $t('addListing.details.listingPreviewText') }}</p> -->
							<p style="margin-bottom:0;">
								{{$t('please click')}}
								<b>{{$t('Confirm the announcement')}}</b>{{$t('to complete the posting process')}} 
							</p>
							<p>{{ $t('addListing.details.listingPreviewText1') }}</p>
						</b-col>
						<b-col cols="12" class="text-center">
							<b-button
								class="btn-submit-search extra-background-color-button"
								@click="previousEditListing"
								>{{ $t('addListing.details.editProductButton') }}</b-button
							>
						</b-col>
						<b-col cols="12">
							<b-button
										type="submit"
										class="btn-submit-search extra-background-color-button"
										@click="openPreviewDialog();"
										id="previewListing"
										>{{ $t('addListing.details.previewButton') }}</b-button
									>
							<b-modal
								id="preview-model"
								class="listing-preview-dialog"
								title="Preview Listing"
								size="xl"
								scrollable
								hide-header
								no-close-on-backdrop
							>
								<ListingDetail :listingDetailsFront="arrListPreview" />
								<template v-slot:modal-footer="{ ok, cancel }">
									<div class="footer">
										<!-- Emulate built in modal footer ok and cancel button actions -->
										<b-button
											variant="success"
											id="accept"
											class="accept"
											@click="
												ok();
											"
											>{{$t('OK')}}</b-button
										>
										<b-button
											variant="danger"
											id="cancel"
											class="cancel"
											@click="
												cancel();
											"
											>{{$t('Cancel')}}</b-button
										>
										<!-- Button with custom close trigger value -->
									</div>
								</template>
							</b-modal>
						</b-col>
						<b-col cols="12">
							<b-button v-on:click="skipAddListing" id="confirmAddListing">{{
								$t('addListing.details.skipButton')
							}}</b-button>
						</b-col>
					</b-row>
				</b-modal>
			</template>
			<template v-if="secondStep">
				<b-row class="button-second-step">
					<b-col cols="12" class="text-center step-info">
						<IconLightClock class="icon-light-clock" />
						<p>{{ $t('addListing.details.reviewText') }}</p>
					</b-col>
					<b-col cols="12" class="button-div">
						<router-link id="home" :to="$i18nRoute({ name: '' })">
							<b-button type="button" class="btn-submit-search"
								>{{$t('back to home page1')}}</b-button
							>
						</router-link>
					</b-col>
				</b-row>
			</template>
		</b-container>
		<template v-if="firstStep">
			<b-row class="box-order-func" v-bind:class="{ active: isActiveCategory }">
				<template v-for="(item, key) in categoriesOptions">
					<b-col v-bind:key="key" cols="6" class="box-func">
						<span
							@click="showCateChild(key + 1, item.id, item.name)"
							v-html="item.url_icon2"
						></span>
						<p>{{ $t(item.name) }}</p>
					</b-col>
				</template>
			</b-row>
			<b-row
				class="box-cate-child"
				v-bind:class="{ active: isActiveCateChild }"
			>
				<b-col cols="12">
					<ul>
						<li></li>
						<template>
							<li
								v-for="(item, key) in childCategories.listing_category_children"
								:key="key"
								@click="selectCateChild(item, key + 1)"
							>
								{{$t(item.name) }}
							</li>
						</template>
					</ul>
				</b-col>
			</b-row>
			<b-row
				class="box-cate-child"
				v-bind:class="{ active: isActiveCateChildChild }"
			>
				<b-col cols="12">
					<ul>
						<li></li>
						<template>
							<li
								v-for="(item, key) in childCategories.childSubCategory.listing_category_children"
								:key="key"
								@click="selectCateChildChild(item, key + 1)"
							>
								{{$t(item.name) }}
							</li>
						</template>
					</ul>
				</b-col>
			</b-row>
			<div
				class="backdrop"
				v-bind:class="{
					active:
						isActiveBackDrop == isActiveCategory ||
						isActiveBackDrop == isActiveCateChild
				}"
				@click="hideBackdrop"
			></div>
		</template>
		<b-modal id="trasnlatation-error"
				centered
				hide-footer
				hide-header
				size="md"
				no-close-on-backdrop>
				<b-container fluid class="d-flex flex-column  align-items-center justify-content-center mt-3">
					<p style="text-align:center" class="w-70 d-flex flex-row align-self-center align-items-center justify-content-center">{{$t('Please complete the announcement details Other languages will be enabled When you fill out the required information to place an announcement only fully')}}</p>
					<b-button class="success-button" @click="closeTranslationDialog">{{$t('bill.save')}}</b-button>
				</b-container>
		</b-modal>
	</div>
</template>
<script>
import MaskedInput from 'vue-text-mask';
import { gmapApi } from 'vue2-google-maps';
import Fileuploader from '@/components/newFileuploader/index';
import Packages from '@/components/packages/Packages';

import ListingDetail from '@/components/listing/listingDetail/ListingDetail';
import EditListingDesktop from '@/components/listing/editListing/EditListingDesktop';
// Icons
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import IconChevronDown from '@/components/icons/IconChevronDown/index';
import IconClipboardList from '@/components/icons/IconClipboardList/index';
import IconLightClock from '@/components/icons/IconLightClock/index';
import CloseIcon from 'vue-material-design-icons/Close.vue';

export default {
	extends: EditListingDesktop,

	components: {
		PencilIcon,
		// MagnifyIcon,
		CheckIcon,
		IconChevronDown,
		Fileuploader,
		IconClipboardList,
		IconLightClock,
		Packages,
		ListingDetail,
		MaskedInput,
		CloseIcon
	},
	data() {
		return {
			isActiveCategory: false,
			isActiveCateChild: false,
			isActiveCateChildChild: false,
			isActiveBackDrop: true
		};
	},
	mounted(){
		if(!this.$root.isAuthenticated){
			this.$root.signIn('add-listing');
		}
	},
	watch:{
		'childCategories.category_attribute_details'(val){
			console.log("val",val)
		}
	},
	methods: {
		hideBackdrop() {
			this.isActiveCategory = false;
			this.isActiveCateChild = false;
			this.isActiveCateChildChild = false;
			// this.hideFileUploader = false;
		},
		showCateChild(key, idCategory, name_cate) {
			this.categoryFirstChange = true;
			this.listing.mainCategory.key = key;
			this.listing.mainCategory.idCategory = idCategory;
			this.isActiveCategory = false;
			this.listing.mainCategory.name = name_cate;
			this.listing.subCategory = null;
			this.listing.subSubCategory = null;
			this.listing.listingAttr.data = {};
			this.validateErrors = {};
			this.validateInputDynamic = [];
			// this.hideFileUploader = false;
		},
		selectCateChild(item) {
			this.listing.subCategory = item;
			this.hideBackdrop();
		},
		selectCateChildChild(item) {
			this.listing.subSubCategory = item;
			this.hideBackdrop();
		},
		changeRadioValue(ev, name) {
			this.listing.listingAttr.data[name] = ev;
			this.$forceUpdate();
		},
		openPreviewDialog(){
			this.previewAddListing();
			// this.hideFileUploader=true;
		}
	}
};
</script>
<style lang="scss">
@import 'editListingMobile.scss';
.mobile-image{
	width: 100%;
}
.yes-mobile-image{
    position: absolute;
    right: 50px;
    bottom: 18px;
    cursor: pointer;
    width: 35%;
}
.no-mobile-image{
    position: absolute;
    left: 30px;
    bottom: 22px;
    cursor: pointer;
    width: 35%;
}
</style>
